// extracted by mini-css-extract-plugin
export default {"createButton":"Vd14dTSsIpqeyMoqF8IafNpnhXXXKlLhpeNEhvcKXaE="};